import React, { useState } from "react";
import LoginForm from "../components/Login";
import SignupForm from "../components/Signup";

import { Form, Input, Button, Select, Row, Col } from "antd";

const { Option } = Select;
const VendorPanel = () => {
  const [isRegistered, setIsRegistered] = useState(true);

  const switchToLogin = () => setIsRegistered(true);
  const switchToSignup = () => setIsRegistered(false);

  return (
    <div style={{ maxWidth: 600, margin: "0 auto", padding: 20 }}>
      {isRegistered ? (
        <LoginForm switchToSignup={switchToSignup} />
      ) : (
        <SignupForm switchToLogin={switchToLogin} />
      )}
    </div>
  );
};

export default VendorPanel;